<template>
  <div class="kk_edit-style">
    <div>Numbers</div>
    <div>Alignments</div>
    <div>Font</div>
    <div>Border</div>
    <div>Fill</div>
    <div>Protection</div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/variables.less";
.kk_edit-style {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  div {
    font-size: small;
    padding: 0.3rem;
    background-color: @kk-color-light-blue;
    color: @kk-color-primary-blue;
    border-radius: @kk-border-radius;
    cursor: pointer;
    &:hover {
      background-color: @kk-color-primary-blue;
      color: @kk-color-light-blue;
    }
  }
}
</style>
